import { styledByTheme } from "../../../themes/architecture/styled-by-theme";
import { ClockLastLoginDefaultBox } from "./clock-last-login.default.box";
import {ClockLastLoginMrGreenBox} from "./clock-last-login.mrgreen.box";
import { ClockLastLoginSiBox } from "./clock-last-login.si.box";
import {ClockLastLoginSICisBox} from "./clock-last-login.siCis.box";

export const ClockLastLoginBox = styledByTheme(ClockLastLoginDefaultBox)
    .forMrGreen(ClockLastLoginMrGreenBox)
    .forSI(ClockLastLoginSiBox)
    .forSICis(ClockLastLoginSICisBox)
    .apply();
